import { render, staticRenderFns } from "./Sig.vue?vue&type=template&id=7c6b3454&scoped=true&"
import script from "./Sig.vue?vue&type=script&lang=js&"
export * from "./Sig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6b3454",
  null
  
)

export default component.exports